<template>
  <div v-loading="loading" class="device-plan-library" :class="showUploadDailog ? 'device-plan-library-dialog' : ''">
    <div class="device-plan-library-container">
      <div class="card_container">
        <template v-for="(videoItem, index) in LibraryList">
          <VideoCard
            :key="videoItem.Id"
            :ref="`card-${index}`"
            :card-info="videoItem"
            :card-index="index"
            :is-edit="isEdit"
            :ischecked="videoItem.ischecked"
            :is-selected="videoItem.isSelected"
            :show-mode="showMode"
            :is-edit-video-scene="isEditVideoScene"
            @changeCheck="changeCheck"
            @clickCard="clickCard(videoItem)"
            @handlerEditScene="lightValue => handlerEditScene(videoItem, lightValue)"
            @closeOthers="closeOthers(index)"
          >
            <div v-if="showTianMuPlayer(videoItem)" slot="action">
              <TianMuPlayer
                :value="videoPlayAction?.DefaultValue"
                :model="videoPlayAction"
                @clickPlayer="
                  v => {
                    changePlayer(videoPlayAction, v)
                  }
                "
              />
            </div>
          </VideoCard>
        </template>
        <template v-if="LibraryList.length === 0 && showMode === APP_SHOW_MODE_ENUM.IFTTT">
          {{ $t('tianmu.noSolution') }}
        </template>

        <template v-if="isEditVideoScene">
          <el-upload
            class="card addCard"
            accept="video/*"
            action="xxx"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleVideoUpload"
          >
            <img src="@/assets/img/planAdd.png" class="planAdd">
            <span class="addTitle">{{ $t('tianmu.uploadVideo') }}</span>
            <span class="addSize">{{ $t('tianmu.videoSize') }}</span>
          </el-upload>
          <!-- <div v-if="limitNum >= 5" class="card_full">
            <img src="@/assets/img/tianmu/full.png" alt="">
            <div class="text">
              {{ $t('tianmu.onlyFiveVedio') }}
            </div>
          </div> -->
        </template>
      </div>
      <div v-if="isEditVideoScene" class="device-plan-library-container-edit">
        <span v-if="!isEdit" class="modify" @click="toggleEditMode">{{ $t('base.modify') }}</span>
        <template v-if="isEdit">
          <span class="cancel" @click="cancelEdit">{{ $t('base.cancel') }}</span>
          <span class="delete" @click="deleteSelectedPlans">{{ $t('base.delete') }}</span>
        </template>
      </div>
    </div>
    <VideoUploadDialog
      :visible.sync="showUploadDailog"
      :video-url="videoUrl"
      @close="closeUploadDialog"
      @add="addNewPlan"
    />
  </div>
</template>

<script>
import { UploadFile } from '@/axios/ICommon.js'
import { alerterror, warning, alertsuccess } from '@/assets/js/common.js'
import { GetTianMuDevicePlanLibrary, AddPlanSceneLib, DelPlanSceneLib, GetPlanInfoDetail, CallAction, FindActionAbilityWithStatus } from '@/axios/IDevice.js'
import { GroupDelete, Create, Edit } from '@/axios/IScene.js'
import TianmuProxy from '@/page/tianmu-design/canvas/CanvasMain/lib/TianmuProxy'
// import OpActionContainer from '@/components/common/layer/OpActionContainer.vue'
// import controlItem from '@/components/common/controlItem'
import { PLANSTATUS, STATUS_DISPLAY, STATUS_ICON, PLANTYPE } from './constants'
import { SYNC_TIANMU_VIDEO_DOWNLOAD_STATUS } from '@/components/OppleDeviceTianMu/tianMuPlayer'
import { CreateSceneBin, DeleteSceneBin, ReSyncConfig, DeleteSkyTemplate } from '@/axios/ITianmu.js'
import VideoCard from './components/VideoCard.vue'
import VideoUploadDialog from './components/VideoUploadDialog.vue'
import TianMuPlayer from '@/components/button/TianMuPlayer.vue'
import { APP_SHOW_MODE_ENUM } from '@/utils/enums'
import { ActionVo } from '@utils/actionsHandler';
import { v4 as uuid } from 'uuid';
import {
  FindDevice
} from '@/axios/IDevice.js'

export default {
  components: {
    // OpActionContainer,
    // controlItem,
    VideoCard,
    VideoUploadDialog,
    TianMuPlayer,
  },
  inject: {
    [SYNC_TIANMU_VIDEO_DOWNLOAD_STATUS]: { default: null },
  },
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
    //设备信息
    deviceModel: {
      type: Object,
      default: () => ({}),
    },
    deviceCardList: {
      type: Array,
      default: () => [],
    },
    PlanId: {
      type: String,
      default: '',
    },
    webContainer: {
      type: Object,
      default: () => null,
    },
    actionList: {
      type: Array,
      default: () => [],
    },
    showMode: {
      type: Number,
      default: 0,
    },
    isEditVideoScene: {
      type: Boolean,
      default: true,
    },
    onlySceneNoList: {
      type: Boolean,
      default: false,
    },
    selectedSceneNo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      PLANSTATUS,
      showUploadDailog: false,
      videoUrl: '',
      cdnUrl: '',
      planName: '',
      loading: false,
      LibraryList: [],
      isEdit: false,
      refreshTimer: null,
      videoDuration: 0,
      videoCurrentTime: 0,
      isSeeking: false,
      wasPlaying: false,
      isPlaying: false,
      fileInfo: null,
      videoThumbnail: null, //视频封面的缩略图.自己截取的是格式是base64
      videoThumbnailURL: null, //接口请求后，返回回来的url地址
      connection: null, // 网络连接对象
      isConnectionSupported: false, // 浏览器是否支持网络连接API
      videoPlayAction: {},
      APP_SHOW_MODE_ENUM,
      transcodingTimer: null, // 转码状态定时器
      refreshInterval: 10*1000, // 刷新间隔(10秒)
      maxTranscodeTime: 30*1000, // 最大转码时间(30秒)
      maxTranscodeRetries: 99, // 最大重试次数
      getPlanInfoDetailResult: {},//方案详情
      industryCode: 1, //行业类型，默认办公
      deletingScenes: false, //是否正在删除场景
    }
  },
  computed: {
    limitNum() {
      return this.LibraryList.filter(item=>item.SceneId !== 0).length
    },
    socketmodel() {
      return this.$store.state.socketmodel //需要监听的数据
    },
  },
  watch: {
    socketmodel(rs) {
      this.functionScoketsync_info_event(rs)
    },
    selectedSceneNo() {
      this.fetchPlanLibrary()
    },
    deviceModel(){
       this.getTianmuVideoControl()
    }
  },
  async mounted() {
    try{
      //创建天幕视频场景的时候，需要查方案详情获取Result，给Create接口用，在创建自动化的时候就不需要这些信息了
      if(!this.PlanId) return
      if(this.showMode === APP_SHOW_MODE_ENUM.DEVICE){
        const { Result } = await this.getPlanInfoDetail({ planId: this.PlanId })
        if (Result) {
          this.getPlanInfoDetailResult = Result || {}
          this.industryCode = Result?.plan_project_info?.industryCode || 1
        }
      }
    }catch(e){
      console.log(e)
    }
    await this.fetchPlanLibrary()
    this.checkConnectionSupport() // 检查网络连接支持

    if (this.deviceModel.constructor === Object && Object.keys(this.deviceModel).length !== 0) {
      //获取天幕设备控制播放能力
      this.getTianmuVideoControl()
    }
  },
  beforeDestroy() {
    this.clearRefreshTimer()
    // 新增：清理转码定时器
    if (this.transcodingTimer) {
      clearInterval(this.transcodingTimer)
      this.transcodingTimer = null
    }
  },
  methods: {
    closeOthers(i) {
      try {
        this.LibraryList.forEach((item, index) => {
        if (index !== i && this.$refs[`card-${index}`]) {
            this.$refs[`card-${index}`][0].isShowEdit = false
          }
        })
      } catch (error) {
        console.log('error: ', error)
      }
    },
    showTianMuPlayer(videoItem) {
      const isSupportPreview = this.$store.state.isSupportPreview
      const item = videoItem
      
      if(item.SceneId !== 0 &&
        item.SceneStatus === this.PLANSTATUS.AllSuccess &&
        item.isSelected &&
        this.isEditVideoScene){
          return true
        }

      if(item.isSelected && !this.isEditVideoScene && isSupportPreview){
        return true
      }
    
     
    },
    async getTianmuVideoControl() {
      let para = {
        classSku: this.deviceModel.ClassSku,
        vDeviceId: this.deviceModel.VDeviceId,
        channelId: this.deviceModel.ChildId || this.deviceModel.ChannelId,
      }
      const res = await FindActionAbilityWithStatus(para)
      if (res.StatusCode === this.$store.state.rightStatusCode) {
        //过滤出视频播放呢控制能力
        const actionList = res.Result?.filter(item => item.ActionList?.[0]?.Values?.some(item => item.ValueType === 'UIControl_TianMu_Player'))
        this.videoPlayAction = actionList[0]?.ActionList[0]
      } else {
        alerterror(this, res.StatusCode)
      }
    },
    changePlayer(action, v) {
      action.Values = action?.Values.map(item => new ActionVo(item));
      this.$emit('clickPlayer', { action, v })
    },
    functionScoketsync_info_event(rs) {
      if (rs.StatusCode !== this.$store.state.rightStatusCode) return

      if (this.deletingScenes) return // 跳过删除后的 socket 推送刷新

      //转码监听
      if (rs.Result[0].Type == 40) {
        const { ResultCode, TemplateId, SceneBinId, SceneBinPath} = rs.Result[0]?.Content || {}
        if (!ResultCode || !TemplateId) return

        const validStatus = [PLANSTATUS.Transcoding, PLANSTATUS.TranscodeFailed, PLANSTATUS.TranscodeCompleted]

        if (validStatus.includes(ResultCode)) {
          const libraryItem = this.LibraryList.find(item => item.Id === TemplateId)
          if (libraryItem) {
            libraryItem.SceneStatus = ResultCode
            libraryItem.icon_status = STATUS_ICON[ResultCode]
            libraryItem.SceneBinId = SceneBinId
            libraryItem.SceneBinPath = SceneBinPath
          }

          // 如果转码完成，刷新列表
          if (ResultCode === PLANSTATUS.TranscodeCompleted) {
            //this.fetchPlanLibrary()
          }

          // 新增：每次状态更新后都重新评估定时器
          this.manageTranscodingTimer()
        }
      }
      //监听场景下发状态
      if (rs.Result[0].Type == 19) {
        this.LibraryList.forEach(n => {
          if (n.SceneId == rs.Result[0].SceneId) {
            this.fetchPlanLibrary(false)
          }
        })
      }
    },

    //状态映射图标

    changeCheck(index) {
      this.LibraryList[index].ischecked = !this.LibraryList[index].ischecked
    },
    //检查兼容性
    checkConnectionSupport() {
      this.isConnectionSupported = 'connection' in navigator || 'mozConnection' in navigator || 'webkitConnection' in navigator

      if (this.isConnectionSupported) {
        this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
        console.log('浏览器不支持网络连接状态API，无法估算上传时间')
      }
    },

    estimateWithDefault(fileSize) {
      // 假设默认上传带宽为0.5Mbps
      const defaultUploadSpeedBytesPerSecond = 0.5 * 125000
      return fileSize / defaultUploadSpeedBytesPerSecond
    },

    //估算文件上传时间
    estimateUploadTime(fileSize) {
      if (!this.isConnectionSupported || !this.connection) {
        return this.estimateWithDefault(fileSize)
      }

      const downlink = this.connection.downlink || 2 // 默认2Mbps
      // 假设上传带宽为下载带宽的1/4
      const uploadBandwidthMbps = downlink / 4
      // 转换为字节/秒 (1Mbps = 125000 字节/秒)
      const uploadSpeedBytesPerSecond = uploadBandwidthMbps * 125000

      // 估算时间(秒) = 文件大小(字节) / 上传速度(字节/秒)
      return fileSize / uploadSpeedBytesPerSecond
    },
    getStatusDisplay(item) {
      //转码成功不提示文案，直接就是待下发
      if (item.SceneStatus === PLANSTATUS.TranscodeCompleted) {
        return
      }
      return STATUS_DISPLAY[item.SceneStatus]
    },

    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer)
        this.refreshTimer = null
      }
    },

    revokeVideoUrl() {
      if (this.videoUrl) {
        URL.revokeObjectURL(this.videoUrl)
        this.videoUrl = ''
      }
    },
    // 上传相关方法
    async handleVideoUpload(file) {
      const errors = await this.validateVideoFile(file)
      if (errors.length > 0) {
        this.showFileValidationError(errors)
        return
      }

      try {
        // 获取视频第一帧作为缩略图
        const thumbnail = await this.generateVideoThumbnail(file.raw)
        this.videoThumbnail = thumbnail

        await this.uploadVideoFile(file)
      } catch (error) {
        console.error('视频处理错误:', error)
        this.$message.error(this.$t('tianmu.videoProcessError'))
      }
    },

    async validateVideoFile(file) {
      const errors = []
      const maxSize = 150 * 1024 * 1024 // 150MB

      if (file.size > maxSize) {
        errors.push(this.$t('tianmu.onlyVideoSize'))
      }

      if (file.raw.type !== 'video/mp4') {
        errors.push(this.$t('tianmu.onlyMp4Format'))
      }

      const videoInfo = await this.extractVideoInfo(file)
      if (!this.validateVideoDuration(videoInfo.duration)) {
        errors.push(this.$t('tianmu.onlyVideoTime'))
      }

      return errors
    },

    showFileValidationError(errors) {
      this.$confirm(errors.join('<br/>'), this.$t('deviceMsg.prompt'), {
        confirmButtonText: this.$t('deviceMsg.save'),
        type: 'warning',
        center: true,
        dangerouslyUseHTMLString: true,
      })
    },

    // 生成视频缩略图
    async generateVideoThumbnail(videoFile) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        // 创建对象URL
        const videoUrl = URL.createObjectURL(videoFile)
        video.src = videoUrl

        // 必须设置的属性以避免浏览器限制
        video.muted = true // 静音是自动播放的必要条件
        video.playsInline = true // 在移动端需要
        video.setAttribute('crossorigin', 'anonymous') // 处理跨域问题

        // 定义事件处理函数
        const onCanPlay = () => {
          try {
            video.currentTime = 0.1 // 使用0.1比0更可靠
          } catch (err) {
            cleanup()
            reject(new Error('')) // 设置播放位置失败
          }
        }

        const onSeeked = () => {
          try {
            // 确保视频已准备好
            if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
              throw new Error('') // 视频数据未准备好
            }

            canvas.width = video.videoWidth || 320
            canvas.height = video.videoHeight || 240

            context.drawImage(video, 0, 0, canvas.width, canvas.height)
            const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.8)
            //要把视频缩略图传上去

            cleanup()
            resolve(thumbnailUrl)
          } catch (error) {
            cleanup()
            reject(error)
          }
        }

        const onError = e => {
          cleanup()
          reject(new Error('')) // `视频加载错误: ${e.target.error ? e.target.error.message : '未知错误'}
        }

        // 超时处理
        const timeoutId = setTimeout(() => {
          cleanup()
          reject(new Error('')) // 视频加载超时
        }, 10000)

        // 统一的清理函数
        const cleanup = () => {
          clearTimeout(timeoutId)
          video.removeEventListener('canplay', onCanPlay)
          video.removeEventListener('seeked', onSeeked)
          video.removeEventListener('error', onError)
          URL.revokeObjectURL(videoUrl)
          video.src = ''
        }

        // 添加事件监听器
        video.addEventListener('canplay', onCanPlay, { once: true })
        video.addEventListener('seeked', onSeeked, { once: true })
        video.addEventListener('error', onError, { once: true })

        // 安全加载视频
        try {
          const loadPromise = video.load()
          if (loadPromise) {
            loadPromise.catch(err => {
              cleanup()
              reject(new Error('')) // `视频加载失败: ${err.message}`
            })
          }
        } catch (err) {
          cleanup()
          reject(new Error('')) // `视频初始化失败: ${err.message}`
        }
      })
    },

    extractVideoInfo(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.src = URL.createObjectURL(file.raw)

        video.onloadedmetadata = () => {
          URL.revokeObjectURL(video.src)
          resolve({
            duration: video.duration,
          })
        }

        video.onerror = () => {
          URL.revokeObjectURL(video.src)
          reject(new Error('Invalid video file'))
        }
      })
    },

    validateVideoDuration(duration) {
      return duration <= 60 // 60秒限制
    },

    async uploadVideoFile(file) {
      function base64ToBlob(base64, mimeType = 'image/png') {
        const byteString = atob(base64.split(',')[1])
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ab], { type: mimeType })
      }

      const formData = new FormData()

      // 将 base64 转换为 Blob
      const blob = base64ToBlob(this.videoThumbnail, 'image/png') // 或根据实际 MIME 类型替换
      formData.append('file', blob, 'thumbnail.png') // 给文件一个名字

      //3. 执行上传操作
      const res = await UploadFile(formData)
      if (res.StatusCode !== this.$store.state.rightStatusCode) {
        alerterror(this, res.StatusCode)
        return
      }
      const { FilePath, RootPath } = res?.Result || {}
      this.videoThumbnailURL = `${RootPath}${FilePath}`
      this.fileInfo = file

      try {
        this.videoUrl = URL.createObjectURL(file.raw)
        //this.cdnUrl = `${res.Result.RootPath}${res.Result.FilePath}`
        this.showUploadDailog = true
        //this.setupVideoControls()
      } catch (error) {
        // console.error('上传失败:', error)
      } finally {
        //this.loading = false
      }
    },

    closeUploadDialog() {
      this.showUploadDailog = false
      this.videoUrl = ''
      this.cdnUrl = ''
      //this.planName = ''
    },

    // 方案库管理
    async fetchPlanLibrary(showLoading = true) {
      if(!this.PlanId && !this.deviceModel?.VDeviceId && !this.deviceModel?.ClassSku) return
      this.loading = showLoading


      try {
        const param = {
          Name: null,
          Types: null,
          PlanId: this.PlanId,
          ResourceType: 'VIDEO',
          PageIndex: 1,
          PageSize: 500,
          VDeviceId: this.deviceModel?.VDeviceId,
          ClassSkus: [this.deviceModel?.ClassSku],
          //IndustryCode: this.industryCode,
          RoomCode: null,
          AppType: 128,
          ProductType: 'skyCanvas',
          IsIncloudeCustom: true,
          OnlyCreated: false,
        }

        const { Result, StatusCode } = await GetTianMuDevicePlanLibrary(param)
        if (Number(StatusCode) !== this.$store.state.rightStatusCode) {
          alerterror(this, StatusCode)
          return
        }

        const dataList = Result?.DataList || []
        this[SYNC_TIANMU_VIDEO_DOWNLOAD_STATUS]?.(dataList)

        let new_data = dataList

        //非编辑状，过滤未成功的视频场景
        if (!this.isEditVideoScene) {
          new_data = new_data.filter(item => {
            return item.SceneStatus === PLANSTATUS.AllSuccess 
          })
        }
        //场景自动化显示指定天幕
        if (this.onlySceneNoList) {
          new_data = new_data.filter(item => {
            return item.SceneId === this.model.DefaultValue
          })

          if (new_data.length === 0) {
            // console.log('没有找到方案')
          }
        }

        this.processLibraryData(new_data || [])
        this.scheduleNextRefreshIfNeeded()
      } catch (error) {
        console.error('获取方案库失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 2. 修改 processLibraryData 方法
    processLibraryData(dataList) {
      this.LibraryList = dataList.map(item => {
        const { SceneStatus, SceneId } = item
        let icon_status = SceneId === 0 && SceneStatus === 0 ? STATUS_ICON[PLANSTATUS['Configing']] : STATUS_ICON[item.SceneStatus] || null

        // 记录转码开始时间
        if (SceneStatus === PLANSTATUS.Transcoding && !item.transcodeStartTime) {
          item = { ...item, transcodeStartTime: Date.now() }
        }

        // 清除非转码视频的重试记录
        if (SceneStatus !== PLANSTATUS.Transcoding) {
          item = {
            ...item,
            transcodeStartTime: null,
            transcodeRetries: null,
          }
        }

        return {
          ...item,
          ischecked: false,
          isSelected: false,
          icon_status: icon_status,
        }
      })

      // 启动或停止转码状态检查定时器
      this.manageTranscodingTimer()
    },

    scheduleNextRefreshIfNeeded() {
      const needsRefresh = this.LibraryList.some(item => item.SceneStatus === PLANSTATUS.Configing && item.SceneId !== 0)

      if (needsRefresh) {
        this.clearRefreshTimer()
        this.refreshTimer = setTimeout(() => {
          this.fetchPlanLibrary(false)
        }, 5 * 60 * 1000)
      }
    },

    manageTranscodingTimer() {
      const hasTranscoding = this.LibraryList.some(item => item.SceneStatus === PLANSTATUS.Transcoding)

      // 如果有转码中的视频且定时器未启动，则启动定时器
      if (hasTranscoding && !this.transcodingTimer) {
        this.transcodingTimer = setInterval(() => {
          this.checkTranscodingStatus()
        }, this.refreshInterval)
      }
      // 如果没有转码中的视频且定时器已启动，则清除定时器
      else if (!hasTranscoding && this.transcodingTimer) {
        clearInterval(this.transcodingTimer)
        this.transcodingTimer = null
      }
    },

    checkTranscodingStatus() {
      const now = Date.now()
      let needsRefresh = false

      this.LibraryList.forEach(item => {
        if (item.SceneStatus === PLANSTATUS.Transcoding) {
          // 计算转码已用时间
          const elapsedTime = item.transcodeStartTime ? now - item.transcodeStartTime : 0
          // 检查是否超时
            // 检查是否超过最大重试次数
            const retries = item.transcodeRetries || 0
            if (retries >= this.maxTranscodeRetries) {
              item.SceneStatus = PLANSTATUS.TranscodeFailed
              item.icon_status = STATUS_ICON[PLANSTATUS.TranscodeFailed]
              return
            }

            needsRefresh = true

            // 更新重试次数和开始时间
            item.transcodeRetries = retries + 1
            item.transcodeStartTime = Date.now() // 重置开始时间

        }
      })

      if (needsRefresh) {
        this.fetchPlanLibrary(false)
      }
    },
    // 方案操作
    async addNewPlan(planName, lightValue) {
      debugger;
      this.planName = planName
      if (!this.planName) return

      this.closeUploadDialog()

      const fileSize = this.fileInfo.size
      const estimatedTime = this.estimateUploadTime(fileSize)
      const tempId = `temp_${uuid()}`;
      // 2. 添加上传中状态的卡片到列表
      const newPlan = {
        Id: tempId, // 临时ID
        Name: this.planName,
        Icon: this.videoThumbnailURL, // 使用视频缩略图
        SnapshotUrl: this.videoThumbnailURL,
        SceneId: 0,
        SceneStatus: PLANSTATUS.UpLoading, // 设置为上传中状态
        ischecked: false,
        icon_status: STATUS_ICON[PLANSTATUS.UpLoading], // 上传中图标
        uploadEstimateTime: estimatedTime, // 估算剩余时间
        TemplateRole: PLANTYPE.Customize,
        fileInfo: this.fileInfo,
        VideoUrl:null
      }
      this.LibraryList.push(newPlan) // 添加到列表顶部

      const formData = new FormData()

      formData.append('file', this.fileInfo.raw)
      //this.loading = true

      //3. 执行视频上传操作
      const res = await UploadFile(formData)
      if (res.StatusCode === this.$store.state.rightStatusCode) {
        const cdnUrl = res?.Result?.RootPath + res?.Result?.FilePath
        //this.imageUrl = url
        newPlan.VideoUrl = cdnUrl
        this.showUploadDailog = false
        // newPlan.SceneStatus = PLANSTATUS.Pending
        // newPlan.icon_status = STATUS_ICON[PLANSTATUS.Pending]
        this.startTranscode(newPlan)
        // 上传成功后更新卡片状态
      } else {
        alerterror(this, res.StatusCode)

        newPlan.SceneStatus = PLANSTATUS.Upload_Failed
        newPlan.icon_status = STATUS_ICON[PLANSTATUS.Upload_Failed]
      }
      //this.loading = false
    },

    //开始转码
    async startTranscode(newPlan) {
      let param = {}
      if(newPlan.Id && ! String(newPlan.Id).startsWith('temp_')){
        param = {
          PlanId: this.PlanId,
          TemplateId: newPlan.Id,
        }
      }else{
        param = {
          PlanId: this.PlanId,
          SnapshotUrl: newPlan?.SnapshotUrl || this.videoThumbnailURL,
          VideoUrl:  newPlan?.VideoUrl,
          TemplateId: null,
          ResourceName: newPlan.Name,
        }
      }
      const result = await CreateSceneBin(param)
        if (result.StatusCode !== this.$store.state.rightStatusCode) {
          // newPlan.SceneStatus = PLANSTATUS.TranscodeFailed //上传成功就转码
          // newPlan.icon_status = STATUS_ICON[PLANSTATUS.TranscodeFailed]
          //失败就刷新，等于转码失败
          this.fetchPlanLibrary()
          alerterror(this, result.StatusCode)
          return
        }
        newPlan.Id = result.Result?.TemplateId
        newPlan.SceneStatus = PLANSTATUS.Transcoding 
        newPlan.icon_status = STATUS_ICON[PLANSTATUS.Transcoding]
        // 新增：转码开始时主动触发定时器管理
        newPlan.transcodeStartTime = Date.now(); // 主动记录开始时间
        newPlan.transcodeRetries = 0; // 初始化重试次数
        this.manageTranscodingTimer()
    },

    toggleEditMode() {
      this.isEdit = true
    },

    cancelEdit() {
      this.isEdit = false
      this.LibraryList.forEach(item => (item.ischecked = false))
    },

    async deleteSelectedPlans() {
      this.deletingScenes = true
      const NON_DELETABLE_STATUSES = [PLANSTATUS.Configing]

      try {
        // 1获取被选中的方案
        let selectedPlans = this.LibraryList.filter(item => item.ischecked)
        if (selectedPlans.length === 0) return

        // 2检查是否有不能删除的方案
        const undeletablePlans = selectedPlans.filter(item => NON_DELETABLE_STATUSES.includes(item.SceneStatus))
        if (undeletablePlans.length > 0) {
          warning(this, this.$t('tianmu.configurationSchemeCannotDelete'))
          selectedPlans = selectedPlans.filter(item => !NON_DELETABLE_STATUSES.includes(item.SceneStatus))
        }

        if (selectedPlans.length === 0) return

        // 3 分类：已配置方案 & 自定义方案
        const configuredSceneIds = selectedPlans
          .filter(item => item.SceneId)
          .map(item => item.SceneId)

        const customPlans = selectedPlans.filter(
          item => item.TemplateRole === PLANTYPE.Customize && !item.SceneId
        )

        // 4并行删除（可优化为并发执行）
        const deleteTasks = []

        if (configuredSceneIds.length > 0) {
          deleteTasks.push(
            (async () => {
              const { StatusCode } = await GroupDelete(configuredSceneIds)
              if (StatusCode !== this.$store.state.rightStatusCode) {
                alerterror(this,  StatusCode)
              }
            })()
          )
        }

        if (customPlans.length > 0) {
          deleteTasks.push(this.deleteCustomPlans(customPlans))
        }

        // 5等待所有删除完成
        await Promise.all(deleteTasks)

        // 6刷新列表
        await this.fetchPlanLibrary()
        this.isEdit = false

      } catch (error) {
        console.error('删除方案失败:', error)
      }finally{
         // 稍微延迟清除，防止 socket 延迟到达
         setTimeout(() => { this.deletingScenes = false },500)
      }
    },



    async deleteSceneBin(plans) {
      const TemplateIds = plans.map(item => item.Id)
      const param = {
        PlanId: this.PlanId,
        TemplateIds: TemplateIds,
      }
      const res = await DeleteSceneBin(param)

      if (res.StatusCode === this.$store.state.rightStatusCode) {
        alertsuccess(this, res.StatusCode)
      } else {
        alerterror(this, res.StatusCode)
      }
    },

    async deleteCustomPlans(plans) {
      const idList = plans.map(item => item.Id)
      const param = {
        TemplateIds:idList,
        PlanId: this.PlanId,
      }
      const { StatusCode } = await DeleteSkyTemplate(param)

      if (StatusCode !== this.$store.state.rightStatusCode) {
        alerterror(this, StatusCode)
      }else{
        //alertsuccess(this, StatusCode)
      }
    },

    async clickCard(item) {

      if(this.limitNum === 5 && item.SceneStatus === PLANSTATUS.TranscodeCompleted){
        warning(this, this.$t('tianmu.maxScenesLimit'))
        return
      }

      const configuringItem = this.LibraryList.find(i => i.SceneStatus === PLANSTATUS.Configing)
      if (configuringItem && configuringItem !== item) {
        return
      }
      if (item.SceneId !== 0 && item.SceneStatus === 1) {
        this.LibraryList.forEach(item => {
          item.isSelected = false
        })
        item.isSelected = !item.isSelected // 切换选中状态
      }
      if (this.isEdit) {
        item.ischecked = !item.ischecked
        return
      }

      if ([PLANSTATUS.Transcoding, PLANSTATUS.UpLoading].includes(item.SceneStatus)) {
        return
      }

      // 封装设置状态的方法
      const updateSceneStatus = status => {
        item.SceneStatus = status
        item.icon_status = STATUS_ICON[status]
      }

      // 处理上传失败状态
      if (item.SceneStatus === PLANSTATUS.Upload_Failed) {
        if (!item.fileInfo?.raw) {
          alerterror(this, this.$t('tianmu.uploadFileMissing'))
          return
        }

        updateSceneStatus(PLANSTATUS.UpLoading)
        const formData = new FormData()
        formData.append('file', item.fileInfo.raw)

        try {
          const res = await UploadFile(formData)
          if (res.StatusCode === this.$store.state.rightStatusCode) {
            const cdnUrl = res?.Result?.RootPath + res?.Result?.FilePath
            this.cdnUrl = cdnUrl
            updateSceneStatus(PLANSTATUS.Pending)
          } else {
            alerterror(this, res.StatusCode)
            updateSceneStatus(PLANSTATUS.Upload_Failed)
          }
        } catch (error) {
          alerterror(this, this.$t('tianmu.uploadError'))
          updateSceneStatus(PLANSTATUS.Upload_Failed)
        }

        return
      }

      // 处理转码失败重新转码逻辑
      if (item.SceneStatus === PLANSTATUS.TranscodeFailed) {
        updateSceneStatus(PLANSTATUS.Transcoding)
        const param = {
          PlanId: this.PlanId,
          TemplateId: item.Id,
        }

        try {
          const res = await CreateSceneBin(param)
          if (res.StatusCode !== this.$store.state.rightStatusCode) {
            alerterror(this, res.StatusCode)
            await this.fetchPlanLibrary()
            //updateSceneStatus(PLANSTATUS.TranscodeFailed);
            return
          }
        } catch (error) {
          return
        }
        return
      }

      //下发失败
      if (item.SceneStatus === PLANSTATUS.Deploy_Failed) {
        await this.reSyncConfig(item.SceneId)
        updateSceneStatus(PLANSTATUS.Configing)
        return
      }

      //处理开始转码
      if(item.SceneStatus === PLANSTATUS.Pending){
        this.startTranscode(item)
        return
      }

      // 根据当前状态选择下一步动作
      if (item.SceneId === 0 && item.SceneStatus === PLANSTATUS.TranscodeCompleted) {
        
        this.configureScene(item)
      } else if (item.SceneStatus === PLANSTATUS.AllSuccess) {
        this.$emit('click', item.SceneId)
        //this.executeScene(item)
      } else if (item.SceneStatus === PLANSTATUS.Configing) {
        warning(this, this.$t('tianmu.configTip'))
      } else {
        this.configureScene(item)
      }
    },

    async reSyncConfig(sceneNo) {
      const param = {
        sceneNo,
      }
      const res = await ReSyncConfig(param)
      if (res.StatusCode === this.$store.state.rightStatusCode) {
        this.fetchPlanLibrary(false)
        return
      } else {
        alerterror(this, res.StatusCode)
      }
    },

    async getPlanInfoDetail({ planId }){
      const res = await GetPlanInfoDetail({ planId})

      if(res.StatusCode !== this.$store.state.rightStatusCode){
        alerterror(this, res.StatusCode)
        return
      }
      return res
    },

    async getCurrentLight() {
      try {
        const deviceInfo = await FindDevice({
          vDeviceId: this.deviceModel.VDeviceId,
          channelId: this.deviceModel.ChildId || this.deviceModel.ChannelId,
        });

        const StatusInfo = JSON.parse(deviceInfo.Result?.StatusInfo || '{}');
        const lightInfo = StatusInfo.find(item => item?.StatusType?.startsWith('0x03')) || {};

        return {
          min: lightInfo.Min,
          max: lightInfo.Max,
          value: Number(lightInfo.Value) || 255
        };
      } catch (error) {
        return {
          min: 0,
          max: 255,
          value: 255
        };
      }     
    },

    async handlerEditScene(videoItem, lightValue) {
      try {
        const tianmuProxy = new TianmuProxy(this.getPlanInfoDetailResult)
        const actionInfo = await tianmuProxy.getVideoScenceData({
          url: videoItem.SceneBinPath,
          deviceList: this.deviceModel,
          lightValue: lightValue
        })

        const param = {
          AutoTemplateParams: { DataContent: { isCanEdit: false, isCanControl: false }  },
          SceneNo: videoItem.SceneId,
          SceneType: 2,
          GpNo: this.deviceModel?.Gpno,
          SecneName: videoItem.Name,
          IconUrl: videoItem.Icon,
          isFavorite: false,
          WellSkyTemplateId: videoItem.Id,
          ShowEntry: 1,
          TransportType: 'VideoScene',
          DeviceList: actionInfo,
        }

        debugger

        const res = await Edit(param);
        this.fetchPlanLibrary()
      } catch (error) {
        return
      }
      
    },

    async configureScene(item) {
      if (!this.PlanId) return

      this.loading = true;

      try {
        const lightValue = await this.getCurrentLight()

        const tianmuProxy = new TianmuProxy(this.getPlanInfoDetailResult)
        const actionInfo = await tianmuProxy.getVideoScenceData({
          url: item?.SceneBinPath,
          deviceList: this.deviceModel,
          lightValue: lightValue.value
        })

        const param = {
          SceneType: 2,
          GpNo: this.deviceModel?.Gpno,
          SecneName: `${this.deviceModel?.DeviceName} ${item.Name}`,
          IconUrl: item.Icon,
          isFavorite: false,
          WellSkyTemplateId: item.Id,
          ShowEntry: 1,
          TransportType: 'VideoScene',
          DeviceList: actionInfo,
          AutoTemplateParams: { DataContent: { isCanEdit: false, isCanControl: false }  },
        }
        const { StatusCode: createStatusCode } = await Create(param)
        if (createStatusCode !== this.$store.state.rightStatusCode) {
          alerterror(this, createStatusCode)
        }

        this.fetchPlanLibrary()
      } catch (error) {
        console.error('配置场景失败:', error)
      } finally {
        this.loading = false
      }
    },

    async executeScene(item) {
      if (item.SceneId === 0) return

      await this.doCallAction(item)
    },

    // 设备控制方法
    doCallActionClassSku(tem, info, model, _type, color, value) {
      if (tem.UI?.NoneNeedCallAction) return
      this.doCallAction(tem)
    },
  },
}
</script>

<style lang="scss" scoped>
.device-plan-library {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }

  .device-plan-library-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    box-sizing: border-box;
    // padding: 40px;
    flex-wrap: wrap;
    position: relative;
    .card_full {
      box-sizing: border-box;
      width: 180px;
      height: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #000000;
      background: #f7f7f7;
      flex-direction: column;
      padding: 0 20px;
      img {
        margin-bottom: 20px;
        width: 25px;
        height: 25px;
      }
    }
    .card_container {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .video_tip {
        position: absolute;
        left: 50%;
        top: 50%;
        color: #fff;
        transform: translateX(-50%);
      }
      .retry {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 60%;
        color: #fff;
      }
      .upload-time-estimate {
        position: absolute;
        left: 50%;
        top: 60%;
        color: #fff;
        transform: translateX(-50%);
      }
    }
    .card {
      width: 180px;
      height: 180px;
      border-radius: 5px;
      position: relative;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;
    }

    .addCard {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #000000;
      background: #f7f7f7;
      flex-direction: column;

      .planAdd {
        width: 20px;
        height: 20px;
      }

      .addTitle {
        font-size: 16px;
        color: #000000;
        line-height: 20px;
        margin-top: 5px;
      }

      .addSize {
        color: #737373;
      }
    }

    .device-plan-library-container-edit {
      position: absolute;
      right: 20px;
      top: -30px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .modify {
        color: #3f9efe;
        cursor: pointer;
      }

      .cancel {
        color: #3f9efe;
        margin-right: 10px;
        cursor: pointer;
      }

      .delete {
        color: #ff4000;
        cursor: pointer;
      }
    }
  }
}

.addCard ::v-deep .el-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.uploadDailog {
  width: 100%;
  height: 100%;

  ::v-deep .el-dialog {
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    overflow: scroll;

    .el-dialog__header {
      background: #2145a4;
      border-radius: 8.53px 8.53px 0px 0px;

      .el-dialog__title {
        color: #ffffff;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
      }
    }
  }
}

.uploadDailog_content {
  width: 100%;
  height: 100%;
  //padding: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  flex-direction: column;
  .planImage {
    width: 600px;
    height: 350px;
    object-fit: cover;
  }

  .tips {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    flex-direction: row;

    span {
      color: #3d3d3d;
      font-size: 15px;
    }

    .inputTitle {
      color: #333333;
      font-weight: 600;
      font-size: 13px;
      margin-right: 10px;
    }

    .yellow {
      color: rgba(255, 178, 0, 1);
      font-size: 15px;
      margin-right: 3px;
    }

    .inputPlan {
      width: 360px;
    }
  }

  .inputDiv {
    margin-top: 50px;
  }

  .addBtn {
    margin-top: 80px;
    padding: 0px 64px;
    background: #2145a4;
    border-radius: 6px;
    font-size: 19px;
    color: #fff;
    line-height: 40px;
    height: 40px;
    text-align: center;
    cursor: pointer;
    transition: opacity 0.3s;

    &.disable {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .video_controls {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 600px;
    height: 40px;
    background: rgba(0, 0, 0, 0.3);

    img {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

    .duration {
      color: #fff;
    }

    .progress-bar {
      width: 300px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.dialog-open-global-style .v-modal {
  display: none !important;
}

.dialog-close-global-style .device-plan-library .v-modal {
  display: none !important;
}

.video_action .other_action {
  align-items: center;
}
/* 
.video_action .other_action .device_div_action {
  padding-left: 0;
}

.video_action .other_action .device_div_action .scence_ctr_span_title {
  margin-left: 0;
} */
</style>
